import { StyleWrapper } from './style'
import MessageHeader from './header'
import MessageList from './list'
import MessageFooter from './footer'
import { FC } from 'react'
import Empty from '@commons/empty'
interface UserProps {
  id: number
  name: string
  avatar: string
}
interface MessageProps {
  receiver: UserProps
  sender: UserProps
}
const Messages: FC<MessageProps> = ({ receiver, sender }) => {
  return (
    <StyleWrapper>
      {!receiver?.id ? (
        <>
          <Empty icon={'noMessageFound'} />
        </>
      ) : (
        <>
          <MessageHeader receiver={receiver} sender={sender} />
          <MessageList receiver={receiver} sender={sender} />
          <MessageFooter receiver={receiver} sender={sender} />
        </>
      )}
    </StyleWrapper>
  )
}

export default Messages
